import React, { useState, useEffect } from "react";
import Img1 from "../../../assets/img/banner/hippa-banner.jpg";

const Banner = () => {
  return (
    <div
      className="card border-0 rounded-4 mb-3 shadow-sm overflow-hidden"
      style={{
        backgroundColor: "#343a40",
        width: 360,
        height: 200,
        position: "relative",
      }}
    >
      <img
        src={Img1}
        alt="HIPAA Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.95,
        }}
      />
      {/* Optional: Overlay content */}
      {/* <div
        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ backgroundColor: "rgba(0,0,0,0.3)" }}>
        <h5 className="text-white fw-bold fs-6">HIPAA Compliance</h5>
      </div> */}
      <GlowOverlay />
    </div>
  );
};

export default Banner;

const GlowOverlay = () => {
  const [showGlow, setShowGlow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGlow(false);
    }, 2500); // Hide after 2.5s

    return () => clearTimeout(timer); // Cleanup
  }, []);

  if (!showGlow) return null;

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: "-200%",
          width: "200%",
          height: "100%",
          background: `linear-gradient(120deg,rgba(255, 255, 255, 0) 40%,rgba(255, 255, 255, 0.4) 50%,rgba(255, 255, 255, 0) 60%)`,
          transform: "skewX(-20deg)",
          animation: "shineAnimation 2.5s ease-in-out infinite",
          pointerEvents: "none",
        }}
      ></div>
      <style>
        {`
          @keyframes shineAnimation {
            0% {
              left: -200%;
            }
            100% {
              left: 100%;
            }
          }
        `}
      </style>
    </>
  );
};
